import type { RosterRow } from './rosterRows';

export type StudentsBannerKind = 'noAccess' | 'confirmSettings' | 'readyToGenerate' | 'waitingForAdmin';

export type StudentsBannerInput = {
  admin: boolean;
  accessUploaded: boolean;
  settingsConfirmed: boolean | null;
  plansGenerated: boolean;
  accessStudentCount: number;
};

export type StudentsBannerCopy = {
  kind: StudentsBannerKind;
  label: string;
  title: string;
  body: string;
};

export function accessStudentCount(rows: RosterRow[]): number {
  return rows.filter((row) => row.noPlan !== true && row.heldOut !== true).length;
}

export function studentsBannerCopy(input: StudentsBannerInput): StudentsBannerCopy | null {
  if (input.plansGenerated) return null;
  if (!input.accessUploaded) {
    return input.admin
      ? {
          kind: 'noAccess',
          label: 'Action plans need ACCESS results',
          title: 'Upload ACCESS files to generate action plans',
          body: 'Plans are built from WIDA ACCESS results. Upload your district’s ACCESS files and a plan is generated for every student with a score on file. Until then, open a sample plan to see what one looks like.',
        }
      : {
          kind: 'noAccess',
          label: 'Action plans need ACCESS results',
          title: 'Action plans will appear once your district uploads ACCESS results',
          body: 'Plans are built from WIDA ACCESS results, and each of your students gets one as soon as your district uploads them. Until then, open a sample plan to see what one looks like.',
        };
  }
  if (!input.admin) {
    return {
      kind: 'waitingForAdmin',
      label: 'Action plans not generated yet',
      title: 'Action plans will appear once your district admin generates them',
      body: 'Your district’s ACCESS results are in. Each of your students with a score on file gets a plan as soon as your district admin generates them.',
    };
  }
  if (input.settingsConfirmed === null) return null;
  if (input.settingsConfirmed) {
    return {
      kind: 'readyToGenerate',
      label: 'Action plans are ready to generate',
      title: 'Action plans are ready to generate',
      body: `Your ACCESS results are in and your settings are confirmed. Generate a plan for each of the ${input.accessStudentCount} students with ACCESS results.`,
    };
  }
  return {
    kind: 'confirmSettings',
    label: 'Confirm your settings to generate plans',
    title: 'Confirm your settings to generate plans',
    body: 'Your ACCESS results are in. Confirm your exit criteria and newcomer and long-term years on the Dashboard, then generate a plan for each student with ACCESS results.',
  };
}
